import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Vuelidate from "vuelidate";
import 'materialize-css/dist/js/materialize.min'
import { Dialog, Button, Input, Select, Option, Message, Table, TableColumn } from 'element-ui';

Vue.config.productionTip = false;

Vue.use(Dialog);
Vue.use(Button);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(Table);
Vue.use(TableColumn);

Vue.use(Vuelidate);

Vue.prototype.$message = Message;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
